import { Directive, input } from '@angular/core';
export enum AvoidCopyAndPasteActions {
  paste = 'paste',
  copy = 'copy',
  cut = 'cut',
}
@Directive({
  selector: '[avoidCopyPaste]',
  host: {
    '(paste)': 'onPaste($event)',
    '(copy)': 'onCopy($event)',
    '(cut)': 'onCut($event)',
  },
})
export class AvoidCopyPasteDirective {
  avoidActions = input<AvoidCopyAndPasteActions[]>([], { alias: 'avoidActions' });
  avoidAllActions = input(false, { alias: 'avoidAllActions' });
  public onPaste(e: KeyboardEvent) {
    if (this.avoidAllActions() || this.avoidActions().includes(AvoidCopyAndPasteActions.paste)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  public onCopy(e: KeyboardEvent) {
    if (this.avoidAllActions() || this.avoidActions().includes(AvoidCopyAndPasteActions.copy)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  public onCut(e: KeyboardEvent) {
    if (this.avoidAllActions() || this.avoidActions().includes(AvoidCopyAndPasteActions.cut)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}
